import Footer from '@/components/layout/footer';
import Header from '@/components/layout/header';
import { SEOProps } from '@/components/ui/SEO';
import PerformanceIndicator from '@/components/ui/performance-indicator';
import SEO from '@/components/ui/SEO';
import { useEnvironment } from '@/hooks/useEnvironment';
import { FeaturesCategoryProvider } from '@/providers/features-category.provider';
import { usePerformance } from '@/providers/performance.provider';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { ReactNode, useEffect } from 'react';

gsap.registerPlugin(ScrollTrigger, SplitText);
ScrollTrigger.config({ ignoreMobileResize: true });

if (
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches
) {
  gsap.defaults({ duration: 0, delay: 0 });
}

const Layout = ({ children, seoProps }: { children: ReactNode; seoProps?: SEOProps }) => {
  const { isProd } = useEnvironment();
  const { isLoading } = usePerformance();

  useEffect(() => {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  }, [isLoading]);

  return (
    <>
      <SEO {...seoProps} />

      {isLoading ? (
        <div className="bg-blue fixed inset-0 z-9998" />
      ) : (
        <FeaturesCategoryProvider>
          <Header />
          <main className="min-h-screen w-screen pt-24">{children}</main>
          <Footer />
        </FeaturesCategoryProvider>
      )}

      {!isProd && <PerformanceIndicator />}
    </>
  );
};

export default Layout;
